<template>

  <div class="p-5 flex flex-col flex-grow gap-2">
    <!-- Info -->

    <div class="flex flex-col text-black pb-5">
      <h2 class="text-2xl font-bold"> Excel Export Info</h2>
      <span
          class="text-md">Dies ist der Excel-Export. Bitte wählen Sie ein Magazine aus, das Sie Exportieren möchten. </span>
      <span class="text-md">Sie können normale sowie auch regionale Magazine Exportieren.</span>
    </div>

    <div class="flex flex-col flex-grow  gap-2 ">
      <div class="flex flex-col w-full   gap-2 flex-grow">
        <div class="flex">
          <span class="p-1 w-[150px]">Projekt:</span>
          <select @change="changeProjects"
              class="outline-0 border border-bg-trader-input-border border-header p-1 w-full shadow-inner-2 text-gray-500"
              v-model="projectId">
            <option v-for="project in projects"
                    :key="project.id"
                    :value="project.id">
              {{ project.name }}
            </option>
          </select>
        </div>
        <div class="flex">
          <span class="p-1 w-[150px]">Magazine:</span>
          <select v-model="magazineId"
                  class="outline-0 border border-bg-trader-input-border border-header p-1 w-full  shadow-inner-2 text-gray-500">
            <option v-for="magazine in magazines"
                    :key="magazine.id"
                    :value="magazine.id">
              {{ magazine.name }}
            </option>
          </select>
        </div>
      </div>
    </div>
    <div class="flex gap-1 justify-between items-center">
      <button class=" text-center bg-trader-dark-gray hover:bg-trader-blue hover:text-white rounded p-2 min-w-[150px]">
        Abbrechen
      </button>
      <a @click="excelExport"
         :href="`/api/v3/excel/magazine/${magazineId}`"
         target="_blank"
          class="text-trader-dark-red text-center bg-trader-red hover:bg-trader-blue hover:text-white rounded p-2 min-w-[150px] cursor-pointer">
        Excel Export
      </a>


    </div>

  </div>

</template>

<script setup lang="ts">


import {onMounted, ref} from "vue";
import {query, type IdName} from "@/graphql";

const props = defineProps({
  magazineId: {
    type: Number,
    default: 0
  },
  projectId: {
    type: Number,
    default: 0
  }
});

const projectId = ref<number>(0);
const magazineId = ref<number>(0);
const projects = ref([] as IdName[]);
const magazines = ref([] as IdName[]);

onMounted(async () => {
  projectId.value = props.projectId;
  await getProjectsWithIdAndName();
  magazineId.value = props.magazineId;

  await getMagazinesWithIdAndName();

});

function changeProjects() {
  magazineId.value = 0;
  getMagazinesWithIdAndName();
}
async function getProjectsWithIdAndName() {
  const [data, err] = await query.getProjectsWithIdAndName();
  projects.value = data;
  if (err) {
    console.error(err);
    return;
  }
}

async function getMagazinesWithIdAndName() {
  const [data, err] = await query.getMagazinesWithIdAndName(projectId.value);
  magazines.value = data;
  if (err) {
    console.error(err);
    return;
  }
}

function excelExport() {
  
}

</script>